import { CoreGlobalNavigationHeaderData } from 'src/types/components';

import DesktopNav from './components/DesktopNav';
import MobileNav from './components/MobileNav';

type OwnProps = {
  className?: string;
};

export type OtherCollegeNavigationProps = OwnProps &
  CoreGlobalNavigationHeaderData['fields']['otherCollegeNavigation'];

const OtherCollegeNavigation = ({
  dropdownLabel,
  dropdownMenu,
  className,
}: OtherCollegeNavigationProps): JSX.Element => {
  return (
    <div className={className}>
      <DesktopNav dropdownLabel={dropdownLabel} dropdownMenu={dropdownMenu} />
      <MobileNav dropdownLabel={dropdownLabel} dropdownMenu={dropdownMenu} />
    </div>
  );
};

export default OtherCollegeNavigation;
